export default __webpack_public_path__ + "static/media/notification.5f1fee46.mp3";